module.exports = __webpack_public_path__ + "img/share_new_user.571408d2.jpg";